import { AiOutlineEye } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { type MerchantStore } from '../../../common/types';

interface IProps {
  stores: MerchantStore[];
}

const RecentStores: React.FC<IProps> = ({ stores }) => {
  return (
    <div className="w-full p-2 my-2 overflow-auto flex flex-col space-y-2 border-b-gray-50">
      {stores.map((store, i) => {
        return (
          <div
            key={i}
            className="w-full bg-gray-50 p-4 flex justify-between justify-items-center items-center rounded-md"
          >
            <div className="flex flex-col">
              <span>{store.name}</span>
              <span className="text-sm text-gray-500">{store.email}</span>
            </div>
            <div className="flex flex-row items-center">
              <span className="px-1 h-full">
                <Link to={`/admin/stores/${store.id}`}>
                  <AiOutlineEye size={20} />
                </Link>
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RecentStores;
